import { auth } from '../../utils/auth';
import { AuthStateLoginStatus } from '../../types/auth';
import { isAuthenticated } from '../../utils/authUtils';
import { MessageWrapper } from './PrivateRouteStyle';
import { ReactNode, useEffect } from 'react';
import { RootState, useAppSelector } from '../../redux/store';

interface PrivateRouteProps {
  component: ReactNode;
}

function PrivateRoute({ component }: PrivateRouteProps) {
  const authState = useAppSelector((state: RootState) => state.auth);

  useEffect(() => {
    if (
      !isAuthenticated(authState.loginStatus) &&
      authState.loginStatus !== AuthStateLoginStatus.LOADING
    ) {
      auth.login(window.location.href, true);
    }
  }, [authState]);

  if (authState.loginStatus === AuthStateLoginStatus.LOADING) {
    return <MessageWrapper>Loading...</MessageWrapper>;
  }

  if (!isAuthenticated(authState.loginStatus)) {
    return <MessageWrapper>Redirecting...</MessageWrapper>;
  }

  return <>{component}</>;
}

export default PrivateRoute;
